import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGerenciadorPrecosDatapoint } from '../../@types';
import { RootState } from '../../@types/RootState';

export type RowData = Partial<IGerenciadorPrecosDatapoint>;

export type GetStoreFamilyClusterModalDatapointsState = RowData[];

const initialState: GetStoreFamilyClusterModalDatapointsState = [];

const slice = createSlice({
  name: 'getStoreFamilyClusterModal/datapoints',
  initialState,
  reducers: {
    SET_GET_STORE_FAMILY_CLUSTER_MODAL_DATAPOINTS: (_state, { payload }: PayloadAction<GetStoreFamilyClusterModalDatapointsState>) => payload,

    UPDATE_GET_STORE_FAMILY_CLUSTER_MODAL_DATAPOINT: (
      state,
      {
        payload,
      }: {
        payload: {
          index: number;
          updatedData: Partial<RowData>;
        };
      },
    ) => {
      state[payload.index] = {
        ...state[payload.index],
        ...payload.updatedData,
      };
    },
    RESET_GET_STORE_FAMILY_CLUSTER_MODAL_DATAPOINTS() {
      return [];
    },
  },
});

export const {
  SET_GET_STORE_FAMILY_CLUSTER_MODAL_DATAPOINTS,
  UPDATE_GET_STORE_FAMILY_CLUSTER_MODAL_DATAPOINT,
  RESET_GET_STORE_FAMILY_CLUSTER_MODAL_DATAPOINTS,
} = slice.actions;

export const selectorGetStoreFamilyClusterModalDatapoints = (state: RootState) => state.getStoreFamilyClusterModalReducer.datapoints;

export default slice.reducer;
